const styles = theme => ({
  header: {
    display: 'flex',
    height: 60,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingLeft: 20,
    paddingRight: 20,
    backgroundColor: '#029AB1',
    color: '#FFF',
  },
  headerTitle: {
    fontSize: '1.1rem',
  },
  headerCloseIcon: {
    color: '#FFF',
  },
});

export default styles;